import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog.vue";
import ObjectValidator from '@/scripts/ObjectValidator';
import Utils from '@/scripts/Utils';
import UnitsServiceServer from "@/services/server/UnitsService";
import SectorsService from "@/services/server/SectorsService";
import ModensService from "@/services/server/ModensService";
import UsersService from "@/services/server/UsersService";
import Rules from "@/utils/Rules";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper";
import { mapGetters } from "vuex";
import DefaultAddImg from "../../../public/img/icons/add_img.png";
import HydrometersService from "@/services/server/HydrometersService";
import WaterProbesService from "@/services/server/WaterProbesService";
import Alerts from "@/pages/Configs/Alerts/Alerts.vue"

import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
// Importação de componentes
import Historics from "@/pages/Units/historics.vue";

const CONSTANTS = {
  route: 'units',
  FormColumns: [
    'Dados Estruturais',
    'Endereço',
    'Dados Extras',
    'Setores',
    'Histórico',
    'Meta',
    'Alertas',
  ],
  TabUnitFirstPage: [
    'Concessionária',
    'Meta',
  ],
  SectorTypes: [
    'Macro',
    'Interno'
  ],
  waterTariffsTypes: [
    'Real',
    'Suprimido 30%',
    'Fixo'
  ],
  sewerTariffsTypes: [
    'Real',
    'Fixo',
    'Sem Esgoto'
  ],
  referenceModeOptions: [
    { text: 'Referência fixa', value: 'fixedBaseline' },
    { text: 'Referência mensal', value: 'monthlyBaseline' },
  ],
  driverTypeOptions: [
    { text: 'Ocupação', value: 'occupancy' },
    { text: 'Produção', value: 'production' },
    { text: 'Atendimento', value: 'attendance' },
    { text: 'Refeições', value: 'meals' },
    { text: 'Vazão', value: 'flow' },
    { text: 'Customizado', value: 'custom' },
  ],
  monthOptions: [
    { text: 'Janeiro', value: '1' },
    { text: 'Fevereiro', value: '2' },
    { text: 'Março', value: '3' },
    { text: 'Abril', value: '4' },
    { text: 'Maio', value: '5' },
    { text: 'Junho', value: '6' },
    { text: 'Julho', value: '7' },
    { text: 'Agosto', value: '8' },
    { text: 'Setembro', value: '9' },
    { text: 'Outubro', value: '10' },
    { text: 'Novembro', value: '11' },
    { text: 'Dezembro', value: '12' },
  ],
  efluentesTratadosTypes: [
    'Água',
    'Esgoto',
    'Água e Esgoto'
  ],
  typeGas: [
    'Gás Natural',
    'GLP'
  ],
  tipoConsumoTypes: [
    "Real/Real",
    "Real/Fixo",
    "Fixo/Real",
    "Fixo/Fixo",
    "Const Cort/Const Cort",
    "Estimado/Estimado",
    "Informado/Informado",
    "Media HD/Media HD",
    "Min Fixed/Min Fixed",
    "Real/Min Fixed"
  ],
  ufList: [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
  ],
  waterSupplyTypeList: [
    { value: null, text: 'Nenhum' },
    { value: "WELL", text: 'Poço' },
    { value: "RESERVOIR", text: 'Reservatório' },
    { value: "DEALERSHIP", text: 'Concessionaria' }
  ],
  faturadoList: [
    'Sim',
    'Não'
  ],
  labels: [
    'Media Antes',
    'Economia',
  ],
  value: [
    200,
    100,
  ],
}
export default {
  components: {
    DatePickerDialog,
    Historics,
    Alerts,
  },
  name: "Units",
  data: () => ({
    ...CONSTANTS,
    flagEditModem: false,
    sectorDialog: false,
    newSectorData: {},
    portsListGenerate: [],
    hydrometerModels: [
      { value: "DN_8", text: '1/4"' },
      { value: "DN_10", text: '3/8"' },
      { value: "DN_15", text: '"1/2"' },
      { value: "DN_20", text: '3/4"' },
      { value: "DN_32", text: '1"' },
      { value: "DN_40", text: '1 1/2"' },
      { value: "DN_50", text: '2"' },
      { value: "DN_65", text: '2 1/2"' },
      { value: "DN_80", text: '3"' },
      { value: "DN_100", text: '4"' },
      { value: "DN_125", text: '5"' },
      { value: "DN_150", text: '6"' },
      { value: "DN_200", text: '8"' },
      { value: "DN_250", text: '10"' },
      { value: "DN_300", text: '12"' },
      { value: "DN_350", text: '14"' },
      { value: "DN_400", text: '16"' },
    ],
    radioInvoiced: false,
    modensWithouUnit: [],
    modensWithouUnitLoading: false,
    sectorsByUnitList: [],
    validSectorForm: true,
    sectorLoadings: {
      delete: false,
      edit: false,
      save: false,
      getData: false,
    },
    usersLoadings: {
      getData: false,
    },
    usersByRank: [],
    selectedUser: [],
    historicsByUnitId: [],

    validForm: true,
    unit: {
      ...ObjectValidator.create('unit'),
      referenceMode: null,
      fixedBaselineWater: null,
      fixedBaselineSewer: null,
      monthlyBaseline: {},
      driverOptions: {
        isEnabled: false,
        driverType: null,
        driverLabel: null,
        driverUnitLabel: null,
        driverReferenceValue: null,
      },
    },
    sector: ObjectValidator.create('sector'),

    datePickerDialog: false,
    newHistoricoConsumo: [],

    removeHistoricoDialog: false,
    removeHistoricoIndex: null,

    itemsSectors: -1,
    dataMediaHistoricoDialog: false,
    dataMediaHistoricoObject: null,
    unwatchDataMediaHistorico: () => { },

    alertGoalActive: false,
    // Snackbar da Mensagem 
    textSnackbar: '',
    timeoutSnackbar: 10000,

    isMainLoading: true,

    columnsToChoose: ["Cliente", "Unidade", "Matrícula", "Grupo de Faturamento", "Franquia"],
    columnToSeach: "Unidade",
    searchText: "",
    isFirstLoadedUnit: false,

    // Área de teste
    dialog: false,
    isAdmin: false,

    // A lista de usuários que é buscado do servidor
    users: [],

    // Lista das unidades de todos os usuários, com referencia a qual usuário
    units: [],
    users_parsed: {},
    users_items: [],
    user_item: null,

    id_client: null,

    // Index da unidade selecionado no openUnit
    index_unit: null,

    // Modo no qual os dados serão apresentados
    readOnly: true,

    // Ação a ser tomada de acordo com as unidades
    // São possíveis 3
    // view   = visualização
    // edit   = edição
    // signup = cadastro
    action: "signup",
    nextTick: false,
    tab: null,
    tabUnit: null,
    selectTabUnitFirstPage: null,
    waterAuthorities: ["Compesa", "Sem Concessionária"],
    dialog: false,
    openModal: false,
    dialogDelete: false,
    isLoadingDeleteUnit: false,
    saveButtonLoading: false,
    editedIndex: -1,
    imageUploadError: undefined,
    user: {
      data: {
        name: "",
        manager: "",
        email: "",
        password: "",
        rank: "",
        status: "Ativo",
        dataList: [],
        metadata: {
          image: undefined,
          imageName: "",
          imageURL: "",
          idType: "",
          idNumber: "",
          address: {},
          phone: "",
        },
      },
      id: "",
    },

    // A unidade nova ou antiga que está sendo editada
    editedItem: {
      ...ObjectValidator.create('unit'),
      referenceMode: null,
      fixedBaselineWater: null,
      fixedBaselineSewer: null,
      monthlyBaseline: {},
      driverOptions: {
        isEnabled: false,
        driverType: null,
        driverLabel: null,
        driverUnitLabel: null,
        driverReferenceValue: null,
      },
    },

    // O item que indica qual a unidade que é para deletar
    deletedItem: null,

    dataHydrometers: [],
    dataWaterProbe: [],
    unidade: {
      ...ObjectValidator.create('unit'),
      referenceMode: null,
      fixedBaselineWater: null,
      fixedBaselineSewer: null,
      monthlyBaseline: {},
      driverOptions: {
        isEnabled: false,
        driverType: null,
        driverLabel: null,
        driverUnitLabel: null,
        driverReferenceValue: null,
      },
    },
    selectedSector: {
      name: "",
      matricula: null,
      meta: null,
      hydrometer: {},
      modem: {},
      historico: [],
    },
    day: '01',
    headers: [
      { text: "" },
      { text: "Unidade" },
      { text: "Franquia"},
      { text: "Matricula" },
      { text: "Grupo de Faturamento" },
      { text: "Endereço" },
      { text: "Ações" }
    ],
    headersSector: [
      { text: 'Nome Setor', value: "name", },
      { text: 'Id Modem', value: 'id_modem', },
      { text: 'Tipo', value: 'waterSupplyType', },
      { text: 'Faturado', value: 'invoiced', },
      { text: 'Hidrômetro', value: 'hydrometerModel', },
      { text: "Ações", value: "actions", sortable: false },
    ],
    options: [{ sortable: true }],
    page: 1,
    averageLine: { name: "( % )", color: "green" },
    historics: [],
    baselineFormDialog: false,
    monthlyBaselineViewDialog: false,
    baselineListLoading: false,
    baselineFormLoading: false,
    baselineConfigs: [],
    monthlyBaselineViewConfig: null,
    baselineHistoryHeaders: [
      { text: 'Status', value: 'timelineStatus' },
      { text: 'Modo', value: 'referenceMode' },
      { text: 'Meta (%)', value: 'metaEconomia' },
      { text: 'Válido de', value: 'validFrom' },
      { text: 'Válido até', value: 'validTo' },
      { text: 'Criado em', value: 'createdAt' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
    baselineFormMode: 'create',
    baselineConfigValidFrom: null,
    baselineConfigValidTo: null,
    baselineForm: {
      id: null,
      referenceMode: null,
      metaEconomia: 0,
      fixedBaselineWater: null,
      fixedBaselineSewer: null,
      monthlyBaseline: {},
      driverOptions: {
        isEnabled: false,
        driverType: null,
        driverLabel: null,
        driverUnitLabel: null,
        driverReferenceValue: null,
      },
      validFrom: null,
      validTo: null,
      createdAt: null,
      updatedAt: null,
      isCurrent: false,
    },
  }),

  methods: {
    createEmptyMonthlyBaseline() {
      return this.monthOptions.reduce((accumulator, { value }) => {
        accumulator[value] = {
          water: null,
          sewer: null,
          reference_economy: null,
          driverReferenceValue: null,
        }
        return accumulator
      }, {})
    },
    createDefaultDriverOptions() {
      return {
        isEnabled: false,
        driverType: null,
        driverLabel: null,
        driverUnitLabel: null,
        driverReferenceValue: null,
      }
    },
    createDefaultBaselineForm() {
      return {
        id: null,
        referenceMode: 'fixedBaseline',
        metaEconomia: 0,
        fixedBaselineWater: null,
        fixedBaselineSewer: null,
        fixedBaselineReferenceEconomy: null,
        monthlyBaseline: this.createEmptyMonthlyBaseline(),
        driverOptions: this.createDefaultDriverOptions(),
        validFrom: null,
        validTo: null,
        createdAt: null,
        updatedAt: null,
        isCurrent: false,
      }
    },
    createUnitWithReferenceFields(unit = {}) {
      return {
        ...unit,
        referenceMode: Object.prototype.hasOwnProperty.call(unit, 'referenceMode') ? unit.referenceMode : null,
        fixedBaselineWater: Object.prototype.hasOwnProperty.call(unit, 'fixedBaselineWater') ? unit.fixedBaselineWater : null,
        fixedBaselineSewer: Object.prototype.hasOwnProperty.call(unit, 'fixedBaselineSewer') ? unit.fixedBaselineSewer : null,
        monthlyBaseline: this.normalizeMonthlyBaseline(unit.monthlyBaseline),
        driverOptions: this.normalizeDriverOptions(unit.driverOptions),
      }
    },
    normalizeMonthlyBaseline(monthlyBaseline) {
      const normalizedBaseline = this.createEmptyMonthlyBaseline()

      if (!monthlyBaseline || typeof monthlyBaseline !== 'object' || Array.isArray(monthlyBaseline)) {
        return normalizedBaseline
      }

      Object.keys(monthlyBaseline).forEach((month) => {
        if (!normalizedBaseline[month]) return

        const baseline = monthlyBaseline[month]
        if (!baseline || typeof baseline !== 'object' || Array.isArray(baseline)) return

        normalizedBaseline[month] = {
          water: Object.prototype.hasOwnProperty.call(baseline, 'water') ? baseline.water : null,
          sewer: Object.prototype.hasOwnProperty.call(baseline, 'sewer') ? baseline.sewer : null,
          reference_economy: Object.prototype.hasOwnProperty.call(baseline, 'reference_economy') ? baseline.reference_economy : null,
          driverReferenceValue: Object.prototype.hasOwnProperty.call(baseline, 'driverReferenceValue') ? baseline.driverReferenceValue : null,
        }
      })

      return normalizedBaseline
    },
    normalizeDriverOptions(driverOptions) {
      const defaultOptions = this.createDefaultDriverOptions()

      if (!driverOptions || typeof driverOptions !== 'object' || Array.isArray(driverOptions)) {
        return defaultOptions
      }

      return {
        ...defaultOptions,
        ...driverOptions,
        isEnabled: Object.prototype.hasOwnProperty.call(driverOptions, 'isEnabled')
          ? Boolean(driverOptions.isEnabled)
          : true,
      }
    },
    normalizeReferenceMode(referenceMode) {
      if (referenceMode === 'fixed') return 'fixedBaseline'
      return referenceMode || 'fixedBaseline'
    },
    toNumberOrNull(value) {
      if (value === null || value === undefined || value === "") return null
      const normalizedValue = typeof value === 'string' ? value.replace(',', '.') : value
      const numberValue = Number(normalizedValue)
      return Number.isNaN(numberValue) ? null : numberValue
    },
    isPositiveNumber(value) {
      const numberValue = this.toNumberOrNull(value)
      return numberValue !== null && numberValue > 0
    },
    getResponseData(response) {
      return response?.data?.data ?? null
    },
    toDateInputValue(value) {
      if (!value) return null
      const dateValue = new Date(value)
      if (Number.isNaN(dateValue.getTime())) return null
      return dateValue.toISOString().slice(0, 10)
    },
    toMonthInputValue(value) {
      if (!value) return null
      if (typeof value === 'string') {
        const match = value.match(/^(\d{4})-(\d{2})/)
        if (match) return `${match[1]}-${match[2]}`
      }
      const dateValue = new Date(value)
      if (Number.isNaN(dateValue.getTime())) return null
      const year = dateValue.getUTCFullYear()
      const month = String(dateValue.getUTCMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    monthInputToISOString(value, boundary = 'start') {
      const monthValue = this.toMonthInputValue(value)
      if (!monthValue) return null
      const [year, month] = monthValue.split('-').map(Number)
      const dateValue = boundary === 'end'
        ? new Date(Date.UTC(year, month, 0, 12, 0, 0, 0))
        : new Date(Date.UTC(year, month - 1, 1, 12, 0, 0, 0))
      return Number.isNaN(dateValue.getTime()) ? null : dateValue.toISOString()
    },
    getMonthInputTime(value) {
      const monthValue = this.toMonthInputValue(value)
      if (!monthValue) return null
      const [year, month] = monthValue.split('-').map(Number)
      const dateValue = new Date(Date.UTC(year, month - 1, 1, 12, 0, 0, 0))
      return Number.isNaN(dateValue.getTime()) ? null : dateValue.getTime()
    },
    dateInputToISOString(value) {
      if (!value) return null
      const dateValue = new Date(`${value}T00:00:00`)
      if (Number.isNaN(dateValue.getTime())) return null
      return dateValue.toISOString()
    },
    getLocalDateInputValue(date = new Date()) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getDateInputTime(value) {
      if (!value) return null
      const dateValue = new Date(`${value}T00:00:00`)
      if (Number.isNaN(dateValue.getTime())) return null
      return dateValue.getTime()
    },
    ensureUnitReferenceFields(unit) {
      unit.referenceMode = this.normalizeReferenceMode(unit.referenceMode)
      unit.monthlyBaseline = this.normalizeMonthlyBaseline(unit.monthlyBaseline)
      unit.driverOptions = this.normalizeDriverOptions(unit.driverOptions)

      if (!Object.prototype.hasOwnProperty.call(unit, 'fixedBaselineWater')) {
        unit.fixedBaselineWater = null
      }

      if (!Object.prototype.hasOwnProperty.call(unit, 'fixedBaselineSewer')) {
        unit.fixedBaselineSewer = null
      }

      return unit
    },
    createBaselineFormFromConfig(config = {}) {
      return {
        ...this.createDefaultBaselineForm(),
        id: config.id || null,
        referenceMode: this.normalizeReferenceMode(config.referenceMode),
        metaEconomia: Object.prototype.hasOwnProperty.call(config, 'metaEconomia')
          ? config.metaEconomia
          : 0,
        fixedBaselineWater: config.fixedBaseline?.water ?? null,
        fixedBaselineSewer: config.fixedBaseline?.sewer ?? null,
        fixedBaselineReferenceEconomy: config.fixedBaseline?.reference_economy ?? null,
        monthlyBaseline: this.normalizeMonthlyBaseline(config.monthlyBaseline),
        driverOptions: this.normalizeDriverOptions(config.driver),
        validFrom: this.toMonthInputValue(config.validFrom),
        validTo: this.toMonthInputValue(config.validTo),
        createdAt: config.createdAt || null,
        updatedAt: config.updatedAt || null,
        isCurrent: Boolean(config.isCurrent),
      }
    },
    resetBaselineState() {
      this.baselineConfigs = []
      this.baselineFormDialog = false
      this.monthlyBaselineViewDialog = false
      this.baselineListLoading = false
      this.baselineFormLoading = false
      this.monthlyBaselineViewConfig = null
      this.baselineFormMode = 'create'
      this.baselineConfigValidFrom = null
      this.baselineConfigValidTo = null
      this.baselineForm = this.createDefaultBaselineForm()
    },
    getBaselineConfigSortValue(config = {}) {
      return config.createdAt || ""
    },
    compareBaselineValidity(a = {}, b = {}) {
      const validFromA = this.toMonthInputValue(a.validFrom) || ''
      const validFromB = this.toMonthInputValue(b.validFrom) || ''

      if (validFromA !== validFromB) {
        return validFromB.localeCompare(validFromA)
      }

      return this.getBaselineConfigSortValue(b).localeCompare(this.getBaselineConfigSortValue(a))
    },
    compareFutureBaselineValidity(a = {}, b = {}) {
      const validFromA = this.toMonthInputValue(a.validFrom) || ''
      const validFromB = this.toMonthInputValue(b.validFrom) || ''

      if (validFromA !== validFromB) {
        return validFromA.localeCompare(validFromB)
      }

      return this.getBaselineConfigSortValue(a).localeCompare(this.getBaselineConfigSortValue(b))
    },
    comparePastBaselineValidity(a = {}, b = {}) {
      const validToA = this.toMonthInputValue(a.validTo) || ''
      const validToB = this.toMonthInputValue(b.validTo) || ''

      if (validToA !== validToB) {
        return validToB.localeCompare(validToA)
      }

      return this.getBaselineConfigSortValue(b).localeCompare(this.getBaselineConfigSortValue(a))
    },
    sortBaselineConfigs(configs = []) {
      const currentBaselineConfig = this.getCurrentBaselineConfigFromList(configs)
      const futureConfigs = configs
        .filter((config) => this.isFutureBaselineConfig(config, currentBaselineConfig))
        .sort((a, b) => this.compareFutureBaselineValidity(a, b))
      const currentConfigs = currentBaselineConfig
        ? configs.filter((config) => config.id === currentBaselineConfig.id)
        : []
      const pastConfigs = configs
        .filter((config) => this.isPastBaselineConfig(config, currentBaselineConfig))
        .sort((a, b) => this.comparePastBaselineValidity(a, b))

      return [...futureConfigs, ...currentConfigs, ...pastConfigs]
    },
    getBaselineDateRange(config = {}) {
      const validFrom = this.toMonthInputValue(config.validFrom)
      const validTo = this.toMonthInputValue(config.validTo)

      if (!validFrom || !validTo) return null

      return {
        validFrom,
        validTo,
      }
    },
    doesBaselineRangeOverlap(rangeA, rangeB) {
      if (!rangeA || !rangeB) return false
      return rangeA.validFrom <= rangeB.validTo && rangeB.validFrom <= rangeA.validTo
    },
    getOverlappingBaselineConfig(form = this.baselineForm) {
      const currentRange = this.getBaselineDateRange(form)
      if (!currentRange) return null

      return this.baselineConfigs.find((config) => {
        if (this.baselineFormMode === 'edit' && this.baselineForm.id && config.id === this.baselineForm.id) {
          return false
        }

        return this.doesBaselineRangeOverlap(currentRange, this.getBaselineDateRange(config))
      }) || null
    },
    getCurrentBaselineConfigFromList(configs = this.baselineConfigs) {
      const today = this.toMonthInputValue(new Date())
      if (!today) return null

      const validConfigs = configs
        .filter((config) => {
          const range = this.getBaselineDateRange(config)
          if (!range) return false
          return range.validFrom <= today && today <= range.validTo
        })
        .sort((a, b) => this.compareBaselineValidity(a, b))

      return validConfigs[0] || null
    },
    getCurrentBaselineConfig() {
      return this.getCurrentBaselineConfigFromList(this.baselineConfigs)
    },
    isPastBaselineConfig(config, currentConfig = this.currentBaselineConfig) {
      const range = this.getBaselineDateRange(config)
      if (!range) return false

      if (currentConfig) {
        const currentRange = this.getBaselineDateRange(currentConfig)
        return Boolean(currentRange && range.validTo < currentRange.validFrom)
      }

      const today = this.toMonthInputValue(new Date())
      return Boolean(today && range.validTo < today)
    },
    isFutureBaselineConfig(config, currentConfig = this.currentBaselineConfig) {
      const range = this.getBaselineDateRange(config)
      if (!range) return false

      if (currentConfig) {
        const currentRange = this.getBaselineDateRange(currentConfig)
        return Boolean(currentRange && range.validFrom > currentRange.validTo)
      }

      const today = this.toMonthInputValue(new Date())
      return Boolean(today && range.validFrom > today)
    },
    getBaselineTimelineStatus(config) {
      if (this.currentBaselineConfig && config && config.id === this.currentBaselineConfig.id) {
        return {
          label: 'Atual',
          color: 'success',
        }
      }

      if (this.isFutureBaselineConfig(config, this.currentBaselineConfig)) {
        return {
          label: 'Futura',
          color: 'info',
        }
      }

      if (this.isPastBaselineConfig(config, this.currentBaselineConfig)) {
        return {
          label: 'Encerrada',
          color: 'grey',
        }
      }

      return {
        label: 'Sem status',
        color: 'grey',
      }
    },
    async loadBaselineConfigs(unitId = this.editedItem.id) {
      if (!unitId) {
        this.baselineConfigs = []
        return
      }

      this.baselineListLoading = true
      try {
        const response = await UnitsServiceServer.getAllBaselineConfig(unitId)
        const baselineConfigs = this.getResponseData(response)
        this.baselineConfigs = this.sortBaselineConfigs(Array.isArray(baselineConfigs) ? baselineConfigs : [])
      } catch (error) {
        console.error(error)
        this.baselineConfigs = []
      } finally {
        this.baselineListLoading = false
      }
    },
    openBaselineForm(mode = 'create', config = null) {
      this.baselineFormMode = mode
      this.baselineForm = this.createBaselineFormFromConfig(config || {})
      this.baselineConfigValidFrom = this.baselineForm.validFrom
      this.baselineConfigValidTo = this.baselineForm.validTo
      this.baselineFormDialog = true
    },
    closeBaselineForm() {
      this.baselineFormDialog = false
      this.baselineFormMode = 'create'
      this.baselineForm = this.createDefaultBaselineForm()
    },
    openMonthlyBaselineView(config = null) {
      const baselineConfig = config || this.currentBaselineConfig || this.latestBaselineConfig
      if (!baselineConfig || this.normalizeReferenceMode(baselineConfig.referenceMode) !== 'monthlyBaseline') return

      this.monthlyBaselineViewConfig = {
        ...baselineConfig,
        monthlyBaseline: this.normalizeMonthlyBaseline(baselineConfig.monthlyBaseline),
        driver: this.normalizeDriverOptions(baselineConfig.driver),
      }
      this.monthlyBaselineViewDialog = true
    },
    closeMonthlyBaselineView() {
      this.monthlyBaselineViewDialog = false
      this.monthlyBaselineViewConfig = null
    },
    getOptionText(options = [], value) {
      return options.find((option) => option.value === value)?.text || '-'
    },
    getBaselineModeText(value) {
      return this.getOptionText(this.referenceModeOptions, this.normalizeReferenceMode(value))
    },
    getDriverTypeText(value) {
      return this.getOptionText(this.driverTypeOptions, value)
    },
    formatBaselineDate(value) {
      const monthValue = this.toMonthInputValue(value)
      if (!monthValue) return '-'
      const [year, month] = monthValue.split('-')
      return `${month}/${year}`
    },
    formatBaselineDateTime(value) {
      if (!value) return '-'
      const parsedDate = new Date(value)
      if (Number.isNaN(parsedDate.getTime())) return '-'
      return parsedDate.toLocaleString('pt-BR')
    },
    sanitizeUnitReferenceFields(unit) {
      const sanitizedUnit = {
        ...unit,
        referenceMode: this.normalizeReferenceMode(unit.referenceMode),
        monthlyBaseline: this.normalizeMonthlyBaseline(unit.monthlyBaseline),
        driverOptions: this.normalizeDriverOptions(unit.driverOptions),
      }

      if (sanitizedUnit.referenceMode === 'fixedBaseline') {
        sanitizedUnit.monthlyBaseline = this.createEmptyMonthlyBaseline()
      }

      if (sanitizedUnit.referenceMode === 'monthlyBaseline') {
        sanitizedUnit.fixedBaselineWater = null
        sanitizedUnit.fixedBaselineSewer = null
      }

      if (!sanitizedUnit.driverOptions.isEnabled) {
        sanitizedUnit.driverOptions = {
          ...this.createDefaultDriverOptions(),
          isEnabled: false,
        }
      } else if (sanitizedUnit.referenceMode === 'fixedBaseline') {
        sanitizedUnit.driverOptions.driverReferenceValue = sanitizedUnit.driverOptions.driverReferenceValue ?? null
      }

      return sanitizedUnit
    },
    buildMonthlyBaselinePayload(monthlyBaseline, isDriverEnabled) {
      const normalizedBaseline = this.normalizeMonthlyBaseline(monthlyBaseline)

      return this.monthOptions.reduce((accumulator, { value }) => {
        accumulator[value] = {
          water: this.toNumberOrNull(normalizedBaseline[value].water),
          sewer: this.toNumberOrNull(normalizedBaseline[value].sewer),
          reference_economy: this.toNumberOrNull(normalizedBaseline[value].reference_economy),
        }

        if (isDriverEnabled) {
          accumulator[value].driverReferenceValue = this.toNumberOrNull(normalizedBaseline[value].driverReferenceValue)
        }

      return accumulator
      }, {})
    },
    buildBaselineConfigPayload(form = this.baselineForm) {
      const normalizedForm = this.ensureUnitReferenceFields({
        ...this.createDefaultBaselineForm(),
        ...form,
        referenceMode: this.normalizeReferenceMode(form.referenceMode),
        monthlyBaseline: this.normalizeMonthlyBaseline(form.monthlyBaseline),
        driverOptions: this.normalizeDriverOptions(form.driverOptions),
      })
      const isDriverEnabled = Boolean(normalizedForm.driverOptions?.isEnabled)
      const referenceMode = this.normalizeReferenceMode(normalizedForm.referenceMode)

      return {
        referenceMode,
        metaEconomia: this.toNumberOrNull(normalizedForm.metaEconomia),
        fixedBaseline: referenceMode === 'fixedBaseline'
          ? {
            water: this.toNumberOrNull(normalizedForm.fixedBaselineWater),
            sewer: this.toNumberOrNull(normalizedForm.fixedBaselineSewer),
            reference_economy: this.toNumberOrNull(normalizedForm.fixedBaselineReferenceEconomy),
          }
          : null,
        monthlyBaseline: referenceMode === 'monthlyBaseline'
          ? this.buildMonthlyBaselinePayload(normalizedForm.monthlyBaseline, isDriverEnabled)
          : null,
        driver: {
          isEnabled: isDriverEnabled,
          driverType: isDriverEnabled ? normalizedForm.driverOptions.driverType : null,
          driverLabel: isDriverEnabled ? normalizedForm.driverOptions.driverLabel : null,
          driverUnitLabel: isDriverEnabled ? normalizedForm.driverOptions.driverUnitLabel : null,
          driverReferenceValue: isDriverEnabled ? this.toNumberOrNull(normalizedForm.driverOptions.driverReferenceValue) : null,
        },
        validFrom: this.monthInputToISOString(normalizedForm.validFrom, 'start'),
        validTo: this.monthInputToISOString(normalizedForm.validTo, 'end'),
        // TODO: keep sending isCurrent for backward compatibility until the backend
        // recalculates the active baseline exclusively from the validity range.
        isCurrent: true,
      }
    },
    stripBaselineConfigFields(unit) {
      const unitPayload = { ...unit }
      const baselineConfigFields = [
        'referenceMode',
        'fixedBaselineWater',
        'fixedBaselineSewer',
        'fixedBaseline',
        'monthlyBaseline',
        'driverOptions',
        'driver',
        'baselineConfig',
      ]

      baselineConfigFields.forEach((field) => {
        delete unitPayload[field]
      })

      return unitPayload
    },
    validateBaselineFormFields() {
      if (!this.baselineForm.referenceMode) {
        showErrorSnackBar("Preencha o modo de referência da meta.")
        return false
      }

      if (!this.baselineForm.validFrom) {
        showErrorSnackBar("Preencha a data inicial da configuração da meta.")
        return false
      }

      if (!this.baselineForm.validTo) {
        showErrorSnackBar("Preencha a data final da configuração da meta.")
        return false
      }

      const baselineMinDateTime = this.getMonthInputTime(this.baselineConfigMinDate)
      const validFromTime = this.getMonthInputTime(this.baselineForm.validFrom)
      const validToTime = this.getMonthInputTime(this.baselineForm.validTo)

      if (!validFromTime || (baselineMinDateTime && validFromTime < baselineMinDateTime)) {
        showErrorSnackBar("A data inicial da configuração da meta deve ser igual ou posterior à data de instalação da Foz.")
        return false
      }

      if (!validToTime) {
        showErrorSnackBar("Preencha uma data final válida para a configuração da meta.")
        return false
      }

      if (validToTime < validFromTime) {
        showErrorSnackBar("O mês final da configuração da meta deve ser igual ou posterior ao mês inicial.")
        return false
      }

      const overlappingBaseline = this.getOverlappingBaselineConfig(this.baselineForm)
      if (overlappingBaseline) {
        showErrorSnackBar("Já existe uma baseline com período de validade sobreposto. Escolha um intervalo fora da vigência da baseline anterior.")
        return false
      }

      if (this.isBaselineDriverEnabled) {
        if (!this.baselineForm.driverOptions.driverType) {
          showErrorSnackBar("Preencha o tipo do driver.")
          return false
        }
        if (!this.baselineForm.driverOptions.driverLabel) {
          showErrorSnackBar("Preencha o rótulo do driver.")
          return false
        }
        if (!this.baselineForm.driverOptions.driverUnitLabel) {
          showErrorSnackBar("Preencha a unidade do driver.")
          return false
        }
      }

      if (this.isBaselineFixedMode) {
        if (!this.isPositiveNumber(this.baselineForm.fixedBaselineWater)) {
          showErrorSnackBar("O valor da água de referência deve ser maior que 0.")
          return false
        }
        if (!this.isPositiveNumber(this.baselineForm.fixedBaselineSewer)) {
          showErrorSnackBar("O valor do esgoto de referência deve ser maior que 0.")
          return false
        }
        if (!this.isPositiveNumber(this.baselineForm.fixedBaselineReferenceEconomy)) {
          showErrorSnackBar("O valor da referência monetária deve ser maior que 0.")
          return false
        }
        if (this.isBaselineDriverEnabled && (this.baselineForm.driverOptions.driverReferenceValue === null || this.baselineForm.driverOptions.driverReferenceValue === "")) {
          showErrorSnackBar("Preencha o valor de referência do driver.")
          return false
        }
      }

      if (this.isBaselineMonthlyMode) {
        for (const { value, text } of this.monthOptions) {
          const baseline = this.baselineForm.monthlyBaseline?.[value] || {}
          if (!this.isPositiveNumber(baseline.water)) {
            showErrorSnackBar(`O valor da água de referência de ${text} deve ser maior que 0.`)
            return false
          }
          if (!this.isPositiveNumber(baseline.sewer)) {
            showErrorSnackBar(`O valor do esgoto de referência de ${text} deve ser maior que 0.`)
            return false
          }
          if (!this.isPositiveNumber(baseline.reference_economy)) {
            showErrorSnackBar(`O valor da referência monetária de ${text} deve ser maior que 0.`)
            return false
          }
          if (this.isDriverEnabled && (baseline.driverReferenceValue === null || baseline.driverReferenceValue === "")) {
            showErrorSnackBar(`Preencha o valor de referência do driver de ${text}.`)
            return false
          }
        }
      }

      return true
    },
    async saveBaselineForm() {
      if (this.baselineFormMode === 'view') {
        this.closeBaselineForm()
        return
      }

      if (!this.validateBaselineFormFields()) return

      this.baselineFormLoading = true
      try {
        const payload = this.buildBaselineConfigPayload(this.baselineForm)

        if (this.baselineFormMode === 'edit' && this.baselineForm.id) {
          await UnitsServiceServer.updateBaselineConfig(this.editedItem.id, this.baselineForm.id, payload)
        } else {
          await UnitsServiceServer.createBaselineConfig(payload, this.editedItem.id)
        }

        await this.loadBaselineConfigs(this.editedItem.id)
        this.closeBaselineForm()
        showSuccessSnackBar("Baseline salva com sucesso!")
      } catch (error) {
        showErrorSnackBar("Ocorreu um erro ao salvar a baseline.")
        console.error(error)
      } finally {
        this.baselineFormLoading = false
      }
    },
    confirmDeleteBaseline(config) {
      showDeleteDialogAlert(`Deseja excluir esta baseline criada em ${this.formatBaselineDateTime(config.createdAt)}?`, () => this.deleteBaselineConfig(config))
    },
    async deleteBaselineConfig(config) {
      try {
        await UnitsServiceServer.deleteBaselineConfig(this.editedItem.id, config.id)
        await this.loadBaselineConfigs(this.editedItem.id)
        showSuccessSnackBar("Baseline removida com sucesso!")
      } catch (error) {
        showErrorSnackBar("Ocorreu um erro ao remover a baseline.")
        console.error(error)
      }
    },
    async checkFranchisee(){
      if(!this.isAdmin){
        this.headers = [
          { text: "" },
          { text: "Unidade" },
          { text: "Matricula" },
          { text: "Grupo de Faturamento" },
          { text: "Endereço" },
        ]
        this.columnsToChoose = ["Cliente", "Unidade", "Matrícula", "Grupo de Faturamento"]
      }
    },
    async checkPortsByModem(idModem){
      await SectorsService.findByModem(idModem)
    },
    isEnabledAction(action) {
      return this.hasAction(this.route, action);
    },
    async openUnitFromRouteQuery() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      if (query.tab !== 'meta' || !query.unitId) return;

      const unit = this.units.find(({ id }) => id === query.unitId);
      if (!unit) return;

      const action = this.isEnabledAction('editUnit') ? 'edit' : 'view';
      await this.openUnit(action, unit);

      this.$nextTick(() => {
        this.tabUnit = 5;

        if (
          query.baselineAction === 'create'
          && action === 'edit'
          && this.canManageBaselineConfigs
        ) {
          this.openBaselineForm('create');
        }
      });
    },
    async insertSector() {
      if (!this.editedItem.id) {
        showErrorSnackBar("Salve a unidade antes de cadastrar setores.")
        return
      }
      this.newSectorData = {}
      this.sectorDialog = true
      this.modensWithouUnitLoading = true
      ModensService.findAllWithoutSector()
        .then(res => this.modensWithouUnit = res.data.data)
        .finally(() => this.modensWithouUnitLoading = false)
    },
    async saveSector() {
      if ((this.$refs.sectorForm) && !this.$refs.sectorForm.validate()) return;
      if (!this.editedItem.id) {
        showErrorSnackBar("Salve a unidade antes de cadastrar setores.")
        return
      }
      this.sectorLoadings.save = true
      try {
        if (this.flagEditModem) {
          const idDoc = this.newSectorData.id_doc || this.newSectorData.id
          const { data: body } = await SectorsService.updateSector(idDoc, this.newSectorData)
          const updated = body?.data ?? this.newSectorData
          this.sectorsByUnitList = this.sectorsByUnitList.map((sector) =>
            (sector.id_doc === idDoc || sector.id === idDoc) ? { ...this.newSectorData, ...updated, id_doc: updated.id_doc || updated.id || idDoc } : sector
          )
        } else {
          this.newSectorData.id_unit = this.editedItem.id
          const { data: body } = await SectorsService.createSector(this.newSectorData)
          const payload = body?.data ?? {}
          const idNewSector = payload.id || payload.id_doc
          this.sectorsByUnitList.push({ ...this.newSectorData, id_doc: idNewSector, id: idNewSector })
        }
        this.sectorDialog = false
        this.flagEditModem = false
      }catch(error){
        showErrorSnackBar("Ocorreu um erro ao salvar setor. Entre em contato com nossa equipe.")
        console.error(error)
      }finally {
        this.sectorLoadings.save = false
      }
    },
    closeSectorDialog() {
      this.sectorDialog = false
      this.flagEditModem = false
    },
    editSector(sector) {
      this.sectorDialog = true
      this.modensWithouUnitLoading = true
      ModensService.getById(sector.id_modem)
        .then((response) => {
          const modem = response?.data?.data
          if (modem) this.modensWithouUnit.push(modem)
        })
      ModensService.findAllWithoutSector()
        .then(res => this.modensWithouUnit.push(...res.data.data))
        .finally(() => this.modensWithouUnitLoading = false)
      this.newSectorData = { ...sector }
      this.flagEditModem = true
    },
    async removeSector(sector) {
      const sectorId = sector.id_doc || sector.id
      this.sectorLoadings.delete = true
      this.newSectorData = sector
      try {
        await SectorsService.deleteSector(sectorId)
        this.sectorsByUnitList = this.sectorsByUnitList.filter(({ id_modem }) => id_modem != sector.id_modem)
        this.newSectorData = {}
      } catch(error){
        showErrorSnackBar("Ocorreu um erro ao deletar setor. Entre em contato com nossa equipe.")
        console.error(error)
      }finally {
        this.sectorLoadings.delete = false
      }
    },
    loadingSectors(sector, disabled) {
      return sector.id_modem === this.newSectorData.id_modem && disabled ? true : false
    },
    orderHistory(historics) {

      if (historics.length) {
        return historics.sort((a, b) => {
          const aDate = new Date(Utils.formatDate(`${a.month}-${a.day}`, '<MM>/<DD>/<YYYY>')).getTime()
          const bDate = new Date(Utils.formatDate(`${b.month}-${b.day}`, '<MM>/<DD>/<YYYY>')).getTime()
          return aDate > bDate ? -1 : aDate < bDate ? 1 : 0;
        })
      } else return []

    },

    removeHistorico() {
      if (this.removeHistoricoIndex === null) return;
      let index = this.removeHistoricoIndex;
      this.newHistoricoConsumo = this.newHistoricoConsumo.filter(i => i !== index).map(i => i > index ? i - 1 : i);
      this.removeHistoricoDialog = false;
      this.removeHistoricoIndex = null;
    },

    async openUnit(action = "view", unitObj = null) {
      this.alertGoalActive = false
      this.sectorsByUnitList = []
      this.historicsByUnitId = []
      this.resetBaselineState()

      this.unwatchDataMediaHistorico();
      this.clearEditedItem();
      this.user_item = null;
      this.action = action;
      this.readOnly = this.action === "view";

      if (unitObj !== null) {
        this.editedItem = this.ensureUnitReferenceFields({ ...unitObj })
        await this.loadBaselineConfigs(unitObj.id)
        // refactor \/
        // const alertActive = await AlertsService.getActiveAlertsPerTypeAndUnit('goal', unitObj.id)
        // if (alertActive.length) this.alertGoalActive = true
        ///////////////////////////////////////////////////////////////

        this.sectorLoadings.getData = true
        // this.usersLoadings.getData = true

        const hydrometersResponse = await HydrometersService.findAll()
        this.dataHydrometers = hydrometersResponse?.data?.data || []
        const waterProbesResponse = await WaterProbesService.findAll()
        this.dataWaterProbe = waterProbesResponse?.data?.data || []

        SectorsService.findByUnit(unitObj.id)
          .then((response) => {
            const list = response.data?.data
            this.sectorsByUnitList = Array.isArray(list) ? list : []
          })
          .catch(() => { this.sectorsByUnitList = [] })
          .finally(() => { this.sectorLoadings.getData = false })
        UnitsServiceServer.getSubCollectionHistorics(unitObj.id)
          .then((response) => {
            if (!this.dialog || this.editedItem?.id !== unitObj.id) return
            const historics = response.data?.data || []
            this.historicsByUnitId = this.orderHistory(historics)
          }).catch()
      } else {
        this.id_client = null;
        this.index_unit = null;
        this.action = "signup";
        this.editedItem = this.ensureUnitReferenceFields(this.createUnitWithReferenceFields(ObjectValidator.create('unit')));
      }
      this.dataMediaHistoricoObject = Utils.instanceDate(this.editedItem.dataMediaHistorico)
      this.unwatchDataMediaHistorico = this.$watch('editedItem.dataMediaHistorico',
        (newValue) => {
          this.dataMediaHistoricoObject = Utils.instanceDate(newValue)
        }
      )
      this.addedDayInOldHistorics();
      this.dialog = true;
    },
    addedDayInOldHistorics() {
      if (this.editedItem.hasOwnProperty("historicos")) {
        this.historicsByUnitId = this.historicsByUnitId.map(d => {
          let day = '01';
          if (d.hasOwnProperty('day')) day = d.day;
          return { ...d, day }
        })
      }
    },
    closeUnit() {
      this.historicsByUnitId = []
      this.sectorsByUnitList = []
      this.flagEditModem = false
      this.resetBaselineState()
      this.sortBy = 'month';
      this.dialog = false;
      this.imageUploadError = undefined;
      this.id_client = null;
      this.index_unit = null;
      this.user_item = null;
      this.action = "";

      this.$nextTick(() => {
        this.editedItem = { ...this.unidade };
        this.selectedSector = { ...this.sector };
        this.editedIndex = -1;
      });
    },

    confirmDeleteUnit(unitObj) {

      this.deletedItem = unitObj;
      showDeleteDialogAlert(`Deseja excluir essa unidade ${unitObj.name}?`, this.removeUnit)
    },

    async removeUnit() {
      try {
        const unit_id = this.deletedItem.id
        this.isLoadingDeleteUnit = true;

        // Soft delete da unidade
        await SectorsService.deleteSectorsByUnit(unit_id)
        await UnitsServiceServer.softDeleteUnit(unit_id);
        await UnitsServiceServer.updateSubCollectionHistorics(unit_id, [])

        this.units = this.units.filter(({ id }) => id != unit_id)

        this.isLoadingDeleteUnit = false;
        this.deletedItem = null;
        this.dialogDelete = false;
        showSuccessSnackBar("Unidade deletada com sucesso.")

      } catch (e) {
        showErrorSnackBar("Erro deletar unidade.")
        this.isLoadingDeleteUnit = false;
        throw new Error(e);
      }
    },

    clearEditedItem() {
      this.editedItem = this.ensureUnitReferenceFields(this.createUnitWithReferenceFields(ObjectValidator.create('unit')));
    },

    pickFile() {
      this.$refs.get_image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (
        files[0] !== undefined &&
        files[0].type.split("/")[0] == "image" &&
        files[0].size < 700000
      ) {
        this.editedItem.imageName = files[0].name;
        if (this.editedItem.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.editedItem.image = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else if (files[0].size > 699999) {
        showErrorSnackBar("Tamanho máximo: 700 KB.")
        this.editedItem.image = "";
        this.editedItem.imageName = "";
      } else {
        showErrorSnackBar("Arquivo inválido.")
        this.editedItem.image = "";
        this.editedItem.imageName = "";
      }
      document.getElementById('get_image').value = "";
    },
    close() {
      this.flagEditModem = false
      this.historicsByUnitId = []
      this.dialog = false;
      this.action = '';
      this.imageUploadError = undefined;
      this.resetBaselineState()
      // this.$refs.form.resetValidation()

      this.$nextTick(() => {
        this.editedItem = this.ensureUnitReferenceFields(this.createUnitWithReferenceFields(ObjectValidator.create('unit')));
        this.selectedSector = { ...this.sector };
        this.editedIndex = -1;
      });
    },
    async save() {
      if ((this.$refs.form) && !this.$refs.form.validate()) return;
      this.saveButtonLoading = true;
      this.sortBy = 'month';
      if (this.action == "edit") {
        await this.editUnit()
      }
      else if (this.action == "signup") {
        await this.createUnit();
      }
      this.saveButtonLoading = false;
    },

    handleTarrifsTypesChange(unit) {
      if (unit.tarrifsTypes.water.tariffType !== "Fixo") {
        unit.tarrifsTypes.water.value = 0;
      }
      if (unit.tarrifsTypes.sewer.tariffType === "Sem Esgoto") {
        unit.tarrifsTypes.sewer.value = 0;
      }
      return unit;
    },

    async editUnit() {
      try {
        const savedObj = this.sanitizeUnitReferenceFields({ ...this.editedItem });
        let unitPayload = this.stripBaselineConfigFields(savedObj)
        unitPayload = this.handleTarrifsTypesChange(unitPayload)

        await UnitsServiceServer.updateUnit(unitPayload.id, unitPayload)
        this.editedItem = savedObj
        this.units = this.units.map((unit) => unitPayload.id === unit.id ? unitPayload : unit)
        this.closeUnit();
        showSuccessSnackBar("Unidade editada com sucesso!")
      } catch (err) {
        showErrorSnackBar("Ocorreu um erro interno ao editar unidade. Entre em contato com nossa equipe.")
        console.error(err)
      }

    },
    async createUnit() {
      let unit_id = null
      try {
        const savedObj = this.sanitizeUnitReferenceFields({ ...this.editedItem });
        let unitPayload = this.stripBaselineConfigFields(savedObj)
        unitPayload = this.handleTarrifsTypesChange(unitPayload)
        const response = await UnitsServiceServer.createUnit(unitPayload);
        unit_id = response.data.data;

        if (this.historicsByUnitId.length) await UnitsServiceServer.createSubCollectionHistorics(unit_id, this.historicsByUnitId)

        this.editedItem = {
          ...savedObj,
          id: unit_id,
        }
        this.units.unshift({
          ...unitPayload,
          id: unit_id,
        })
        this.sectorsByUnitList = []
        this.closeUnit();
        showSuccessSnackBar("Unidade cadastrada com sucesso!")
      } catch (err) {
        showErrorSnackBar("Ocorreu um erro interno ao salvar unidade. Entre em contato com nossa equipe.")
        console.error(err)
        if (unit_id) await UnitsServiceServer.hardDeleteUnit(unit_id)
      }
    },
    /*
    * Converte um objeto que tem valor de chave nula
    */
    convertUndefinedToNullValue(obj) {
      Object.keys(obj).forEach(
        key => {
          if (obj[key] === undefined) obj[key] = null;
        }
      );
      return obj;
    },
    filterModens(modem) {
      let modensFilter = this.getModems.filter((i) => {
        return i.unit_id == null
      })
      if (modem.name !== undefined) modensFilter.unshift(modem.name)

      return modensFilter
    },
    waterSupplyTypeSlug(waterSupplyType) {
      return this.waterSupplyTypeList.find((waterSupply) => waterSupply.value === waterSupplyType).text
    },
    hydrometerModelsSlug(hydrometerModel) {
      let result = this.dataHydrometers.find((hydrometer) => hydrometer.id === hydrometerModel.id_sensor)
      return result? result.name : "Indefinido!"
    },

    getIdUserByName(userName) {
      for (let index in this.users_parsed) {
        let userObj = this.users_parsed[index];
        if (userObj.data.name.toUpperCase() === userName.toUpperCase()) {
          return userObj;
        }
      }
    },

    getImage(userId) {
      const user = this.usersByRank.find(({ id }) => userId === id)
      if (user) return user.metadata?.imageURL ? user.metadata.imageURL : DefaultAddImg
      else return DefaultAddImg
    },
    getRegistration(registration) {
      return registration == null || registration == "" ? "Não há matricula" : registration
    },
    getInvoicingGroup(invoicingGroup) {
      return invoicingGroup != null ? invoicingGroup : '- / -';
    },
    getAddress(address) {
      let hasBairro = !address ? false : !address.bairro ? false : typeof address.bairro === 'string' ? address.bairro.length > 0 : false;
      let hasUF = !address ? false : !address.uf ? false : typeof address.uf === 'string' ? address.uf.length > 0 : false;
      return `${hasBairro ? this.capitalize(address.bairro) : '-'} / ${hasUF ? address.uf.toUpperCase() : '-'}`;
    },
    /*
    * Adiciona as chaves de obj dentro do objeto de referencia
    */

    capitalize(str) {
      let ignoreRegex = /^((d)?((a|e|i|o|u)(s)?)|ou|.{1,2})$/gi;
      return str
        .replace(/(^ | $)/, '')
        .replace(/( +)/, ' ')
        .split(/ /)
        .map(word => word.match(ignoreRegex) ? word : (word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
        .join(" ");
    },

    selectUser(userId) {
      this.selectedUser = this.usersByRank.find(({ id }) => userId === id)
      this.editedItem.id_franchisee = this.selectedUser.manager
      this.editedItem.name_client = this.selectedUser.name
      this.editedItem.image = this.selectedUser.metadata?.imageURL ? this.selectedUser.metadata.imageURL : DefaultAddImg
    },
    changeHistorics(historics) {
      this.historicsByUnitId = historics.historicos
      this.editedItem.dataMediaHistorico = historics.dataMediaHistorico
      this.editedItem.averageBeforeFoz = parseFloat(historics.averageBeforeFoz)
      this.editedItem.lastReadingDate = historics.lastReadingDate ? new Date(historics.lastReadingDate) : null
    },
    async saveInstallationDateFromHistorics(historics) {
      const previousItem = { ...this.editedItem }
      const nextItem = {
        ...this.editedItem,
        dataMediaHistorico: historics.dataMediaHistorico,
        averageBeforeFoz: parseFloat(historics.averageBeforeFoz),
        lastReadingDate: historics.lastReadingDate ? new Date(historics.lastReadingDate) : null,
      }

      this.historicsByUnitId = historics.historicos
      this.editedItem = nextItem

      if (!this.editedItem.id) return

      try {
        const savedObj = this.sanitizeUnitReferenceFields({ ...this.editedItem });
        let unitPayload = this.stripBaselineConfigFields(savedObj)
        unitPayload = this.handleTarrifsTypesChange(unitPayload)

        await UnitsServiceServer.updateUnit(unitPayload.id, unitPayload)
        this.editedItem = savedObj
        this.units = this.units.map((unit) => unitPayload.id === unit.id ? unitPayload : unit)
      } catch (error) {
        this.editedItem = previousItem
        throw error
      }
    },
    async handleCEPChange(CEP) {
      if (!CEP || CEP.length < 10) return
      this.is_loading = true
      this.editedItem.address.uf = null
      this.editedItem.address.cidade = null
      this.editedItem.address.bairro = null
      this.editedItem.address.logradouro = null
      this.editedItem.address.numero = this.editedItem.address.numero ? this.editedItem.address.numero : null
      this.editedItem.address.complemento = this.editedItem.address.complemento ? this.editedItem.address.complemento : null
      let url = "https://viacep.com.br/ws/" + CEP.replace(/\D/g, "") + "/json/";
      await fetch(url)
          .then((response) => response.json())
          .then((responseJson) => {
              var { bairro, localidade, logradouro, uf } = responseJson
              this.editedItem.address.uf = uf
              this.editedItem.address.cidade = localidade
              this.editedItem.address.bairro = bairro
              this.editedItem.address.logradouro = logradouro
          })
          .catch((err) => {
              console.error("Erro", err)
          });
          const enderecoCompleto = `${this.editedItem.address.logradouro}, ${this.editedItem.address.bairro}, ${this.editedItem.address.cidade} - ${this.editedItem.address.uf}, Brasil`;
          const nominatimURL = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(enderecoCompleto)}`;
          await fetch(nominatimURL, {
            headers: {
              'User-Agent': 'DefaultUserAgent/1.0' 
            }
          })
          .then(res => res.json())
          .then(data => {
            if (data && data.length > 0) {
              const latitude = data[0].lat;
              const longitude = data[0].lon;
              this.editedItem.address = {
                ...this.editedItem.address,
                lat: latitude,
                lng: longitude
              };
            }
          })
          .catch((err) => {
            console.error("Erro", err)
          });
      this.is_loading = false
    },
  },

  computed: {
    ...mapGetters([
      "getCurrentUserRank",
      "getCurrentUserID",
      "hasAction",
    ]),
    getGoalEconomy() {
      const averageBeforeFoz = this.getAverageBeforeFoz
      return Number((averageBeforeFoz - (averageBeforeFoz * (this.displayedMetaEconomia / 100))).toFixed(2))
    },
   
    getAverageBeforeFoz() {
      if (this.historicsByUnitId.length && this.editedItem.dataMediaHistorico) {
        let avaregeBefore = []

        this.historicsByUnitId.forEach((historic) => {
          if (new Date(historic.month).getTime() < new Date(this.editedItem.dataMediaHistorico).getTime()) {
            avaregeBefore.push(historic.consumption_cubic_meters)
          }
        })
        return avaregeBefore.length ? Number((avaregeBefore.reduce((a, b) => a + b) / avaregeBefore.length).toFixed(2)) : 0
      }
      return 0
    },
    getAverageWaterBeforeFoz() {
      if (this.historicsByUnitId.length && this.editedItem.dataMediaHistorico) {
        let averageBefore = []

        this.historicsByUnitId.forEach((historic) => {
          if (new Date(historic.month).getTime() < new Date(this.editedItem.dataMediaHistorico).getTime()) {
            if (historic.water_cubic_meters !== null && historic.water_cubic_meters !== undefined && historic.water_cubic_meters !== "") {
              averageBefore.push(Number(historic.water_cubic_meters))
            }
          }
        })

        return averageBefore.length ? Number((averageBefore.reduce((a, b) => a + b, 0) / averageBefore.length).toFixed(2)) : 0
      }
      return 0
    },
    getAverageSewerBeforeFoz() {
      if (this.historicsByUnitId.length && this.editedItem.dataMediaHistorico) {
        let averageBefore = []

        this.historicsByUnitId.forEach((historic) => {
          if (new Date(historic.month).getTime() < new Date(this.editedItem.dataMediaHistorico).getTime()) {
            if (historic.sewer_cubic_meters !== null && historic.sewer_cubic_meters !== undefined && historic.sewer_cubic_meters !== "") {
              averageBefore.push(Number(historic.sewer_cubic_meters))
            }
          }
        })

        return averageBefore.length ? Number((averageBefore.reduce((a, b) => a + b, 0) / averageBefore.length).toFixed(2)) : 0
      }
      return 0
    },
    rulesRequired() {
      return Rules.required();
    },
    rulesUnitName() {
      return [
        ...Rules.required(),
        value => !(value && value.includes('/')) || "O nome da unidade não pode conter /"
      ];
    },
    clientName() {
      const client = this.usersByRank.find(({ id }) => this.editedItem.id_client === id)
      if (client) return client.metadata?.idNumber ? client.metadata.idNumber : ""
      return ""
    },
    formTitle() {
      if (this.action == "view") return "Visualização da Unidade";
      else if (this.action == "signup") return "Adicionar Unidade";
      else if (this.action == "edit") return "Editar Unidade";
    },
    getUnitsLocal() {
      let items = []
      let unity = this.units.sort(function (a, b) {
        return a.id_franchisee < b.id_franchisee ? -1 : a.id_franchisee > b.id_franchisee ? 1 : 0;
      });
      let search = 'name'
      function searchUnit(search, searchText) {
        searchText = Utils.defaultSpace(searchText)
        items = unity.filter((unit) => {
          if (unit[search] !== null && unit[search] !== undefined) {
            return (
              Utils.defaultSpace(unit[search]).toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
          } else if (searchText == '') return unit

        });
      }
      switch (this.columnToSeach) {
        case 'Unidade':
          search = 'name'
          searchUnit(search, this.searchText)
          break;
        case 'Franquia':
          search = 'franchiseeName'
          searchUnit(search, this.searchText)
        break;
        case 'Cliente':
          search = 'name_client'
          searchUnit(search, this.searchText)
          break;
        case 'Matrícula':
          search = 'matricula'
          searchUnit(search, this.searchText)
          break;
        case 'Grupo de Faturamento':
          search = 'grupoFaturamento'
          searchUnit(search, this.searchText)
          break;
      }
      return items
    },
    isActiveOnlyView() {
      return this.action == "view";
    },
    hasHistoricBefore() {
      return this.getAverageBeforeFoz !== 0
    },
    canManageBaselineConfigs() {
      return Boolean(this.editedItem?.id) && this.hasHistoricBefore
    },
    latestBaselineConfig() {
      return this.baselineConfigs[0] || null
    },
    currentBaselineConfig() {
      return this.getCurrentBaselineConfig()
    },
    displayedMetaEconomia() {
      if (this.currentBaselineConfig && this.currentBaselineConfig.metaEconomia != null) {
        return this.currentBaselineConfig.metaEconomia
      }
      return this.editedItem.metaEconomia != null ? this.editedItem.metaEconomia : 0
    },
    isFixedBaselineMode() {
      return this.editedItem.referenceMode === 'fixedBaseline'
    },
    isMonthlyBaselineMode() {
      return this.editedItem.referenceMode === 'monthlyBaseline'
    },
    isDriverEnabled() {
      return Boolean(this.editedItem.driverOptions?.isEnabled)
    },
    isBaselineFixedMode() {
      return this.baselineForm.referenceMode === 'fixedBaseline'
    },
    isBaselineMonthlyMode() {
      return this.baselineForm.referenceMode === 'monthlyBaseline'
    },
    isBaselineDriverEnabled() {
      return Boolean(this.baselineForm.driverOptions?.isEnabled)
    },
    hasLatestMonthlyBaseline() {
      return Boolean(
        this.currentBaselineConfig &&
        this.normalizeReferenceMode(this.currentBaselineConfig.referenceMode) === 'monthlyBaseline'
      )
    },
    baselineConfigMinDate() {
      return this.toMonthInputValue(this.editedItem.dataMediaHistorico) || new Date().toISOString().slice(0, 7)
    },
    baselineConfigValidToMinDate() {
      return this.baselineForm.validFrom || this.baselineConfigMinDate
    },
    baselineFormTitle() {
      if (this.baselineFormMode === 'view') return 'Visualizar Baseline'
      if (this.baselineFormMode === 'edit') return 'Editar Baseline'
      return 'Nova Baseline'
    },
    showUnitSaveButton() {
      return !['3', '4', '5', '6'].includes(String(this.tabUnit))
    },
    isEdit() {
      return this.action == "edit";
    },
    getCurrentImage() {
      const user = this.usersByRank.find(({ id }) => this.editedItem.id_client === id)
      if (user) return user.metadata?.imageURL ? user.metadata.imageURL : DefaultAddImg
      else return DefaultAddImg
    },
    isActiveViewSewerTarrifsTypes() {
      return this.editedItem.tarrifsTypes.sewer.tariffType && this.editedItem.tarrifsTypes.sewer.tariffType != 'Real' ? true : false;
    },
    isActiveWaterTarrifsTypes() {
      return this.editedItem.tarrifsTypes.water.tariffType && this.editedItem.tarrifsTypes.water.tariffType === 'Fixo' ? true : false;
    },
  },
  watch: {

  },
  async created() {
    UsersService.findAllClients()
      .then((response) => this.usersByRank = response.data.data)
    const response = await UnitsServiceServer.findAllFranchisee()
    this.units = response.data.data
    const hydrometersResponse = await HydrometersService.findAll()
    this.dataHydrometers = hydrometersResponse?.data?.data || []
    const waterProbesResponse = await WaterProbesService.findAll()
    this.dataWaterProbe = waterProbesResponse?.data?.data || []
    if (this.getCurrentUserRank === "Super Admin" || this.getCurrentUserRank === "Admin") this.isAdmin = true
    this.checkFranchisee()
    this.isMainLoading = false;
    await this.openUnitFromRouteQuery();
  },
};
